/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./advertiser-dialog.vue?vue&type=template&id=0f236d0d&scoped=true&"
import script from "./advertiser-dialog.vue?vue&type=script&lang=ts&"
export * from "./advertiser-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f236d0d",
  null
  
)

export default component.exports